import { ask_klue_interaction } from './ask_klue_interaction';
import { call_data_sync_auth_modified } from './call_data_sync_auth_modified';
import { call_data_sync_configuration_complete } from './call_data_sync_configuration_complete';
import { call_data_sync_toggled } from './call_data_sync_toggled';
import { card_interaction } from './card_interaction';
import { chat_feedback_prompt_action } from './chat_feedback_prompt_action';
import { chatbot_copy_action } from './chatbot_copy_action';
import { chatbot_followup_action } from './chatbot_followup_action';
import { compete_answer_comparison_action } from './compete_answer_comparison_action';
import { competitive_dashboard_action } from './competitive_dashboard_action';
import { dashboard_tile_action } from './dashboard_tile_action';
import { data_sync_auth_modified } from './data_sync_auth_modified';
import { data_sync_configuration_complete } from './data_sync_configuration_complete';
import { deal_tip_flag } from './deal_tip_flag';
import { digest_action } from './digest_action';
import { digest_story_add } from './digest_story_add';
import { digest_take_action } from './digest_take_action';
import { drive_data_sync_auth_modified } from './drive_data_sync_auth_modified';
import { drive_data_sync_configuration_complete } from './drive_data_sync_configuration_complete';
import { impression } from './impression';
import { insights_action } from './insights_action';
import { integration_card_action } from './integration_card_action';
import { intel_action } from './intel_action';
import { landing_page_action } from './landing_page_action';
import { search_action } from './search_action';

import type { EventDefinition } from '../types';

export const eventDefinitions: Record<string, EventDefinition> = {
  ask_klue_interaction,
  call_data_sync_auth_modified,
  call_data_sync_configuration_complete,
  call_data_sync_toggled,
  card_interaction,
  chat_feedback_prompt_action,
  chatbot_copy_action,
  chatbot_followup_action,
  compete_answer_comparison_action,
  competitive_dashboard_action,
  dashboard_tile_action,
  data_sync_auth_modified,
  data_sync_configuration_complete,
  deal_tip_flag,
  digest_action,
  digest_story_add,
  digest_take_action,
  drive_data_sync_auth_modified,
  drive_data_sync_configuration_complete,
  impression,
  insights_action,
  integration_card_action,
  intel_action,
  landing_page_action,
  search_action,
};
